import React from "react";
import styled from "styled-components";

import toggleDown from "../img/toggle_down.png";

const DisclosureChevron = ({ expanded = false, ...props }) => (
  <ChevronIcon
    {...props}
    src={toggleDown}
    alt=""
    aria-hidden="true"
    $expanded={expanded}
  />
);

const ChevronIcon = styled.img`
  display: block;
  width: 8px;
  height: 4px;
  flex: 0 0 auto;
  transform: ${({ $expanded }) => ($expanded ? "rotate(-180deg)" : "rotate(0deg)")};
  transition: transform 0.15s ease;
`;

export default DisclosureChevron;
